import { MatSnackBar } from "@angular/material";

export function sbErrorHandler(sbService: MatSnackBar, error: Error) {
    const sb = sbService.open(`❌ ${error.name}: ${error.message}`, "Dismiss");
    sb.onAction().subscribe(_ => sb.dismiss());
    console.error(error);
}
